import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-company-scripts',
  templateUrl: './company-scripts.component.html',
  styleUrls: ['./company-scripts.component.scss']
})
export class CompanyScriptsComponent implements OnInit {

  public tawkUrl = 'https://embed.tawk.to/5d7261c277aa790be332c5f0/default';
  constructor() { }

  ngOnInit(): void {

    if(true)
    {
      this.tawkUrl ='https://embed.tawk.to/5d66865d77aa790be331319d/default';
    }
  }

}


  //   }
  //   ngOnInit() {
  //       this._script.loadScripts('body', ['assets/vendors/base/vendors.bundle.js', 'assets/demo/default/base/scripts.bundle.js'], true)
  //           .then(result => {
  //               Helpers.setLoading(false);
  //               // optional js to be loaded once
  //               this._script.loadScripts('head', ['assets/vendors/custom/fullcalendar/fullcalendar.bundle.js'], true);
  //           });